import Combobox from "@/components/Combobox";
import InputError from "@/components/InputError";
import SkeletonRow from "@/components/SkeletonRow";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { web } from "@/config/System";
import { listSumberInformasi } from "@/constants";
import useSessionStorage from "@/hooks/useSessionStorage";
import {
  getDataKeluargaTambahan,
  getDataSurvey,
  getListDataKeluarga,
} from "@/services/getData";
import { DataKeluarga, DataSurvey as DataSurveyType } from "@/types";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

export default function DataSurvey({
  idDataPendaftaran,
  error,
  form,
  setForm,
}: // isValidPermanen,
{
  idDataPendaftaran: string;
  error: any;
  form: DataSurveyType;
  setForm: Dispatch<SetStateAction<DataSurveyType>>;
  // isValidPermanen: boolean;
}) {
  // const [searchParams] = useSearchParams();
  // const sessionPeriode?.id_sys_periode = searchParams.get("periode");
  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  });

  const [openSumberInformasi, setOpenSumberInformasi] = useState(false);

  const { data: dataSurvey } = useQuery({
    queryKey: ["dataSurvey"],
    queryFn: () => getDataSurvey(sessionPeriode?.id_sys_periode || ""),
    enabled: !!sessionPeriode?.id_sys_periode,
  });

  const { data: dataKeluarga, isPending: isPendingDataKeluarga } = useQuery({
    queryKey: ["listDataKeluarga", sessionPeriode?.id_sys_periode],
    queryFn: () => getListDataKeluarga(sessionPeriode?.id_sys_periode || ""),
  });

  const {
    data: dataKeluargaTambahan,
    isPending: isPendingDataKeluargaTambahan,
  } = useQuery({
    queryKey: ["dataKeluargaTambahan"],
    queryFn: () => getDataKeluargaTambahan(idDataPendaftaran),
  });

  const totalPenghasilan = dataKeluarga?.reduce(
    (acc: number, curr: DataKeluarga) => {
      return acc + (Number(curr.penghasilan) ?? 0);
    },
    0,
  );

  const isBiayaHidupPerbulanMelebihiTotalPenghasilan =
    dataKeluargaTambahan?.biaya_hidup_keluarga_perbulan > totalPenghasilan;
  // const queryClient = useQueryClient();
  // const { mutate, error } = useMutation({
  //   mutationFn: patchData,
  //   onSuccess: (data) => {
  //     queryClient.invalidateQueries({ queryKey: ["dataStep"] });
  //     queryClient.invalidateQueries({ queryKey: ["dataSurvey"] });
  //     toast.success(data?.message || "Success.");
  //   },
  //   onError: (error: AxiosError<ErrorResponse>) => {
  //     const err = error as AxiosError<ErrorResponse>;
  //     toast.error(
  //       err?.response?.data?.message || "An unexpected error occurred."
  //     );
  //   },
  // });

  // const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  //   event.preventDefault();
  //   mutate(form);
  // };

  useEffect(() => {
    if (!dataSurvey) return;
    setForm((prev) => ({ ...prev, ...dataSurvey }));
  }, [dataSurvey]);

  if (isPendingDataKeluarga || isPendingDataKeluargaTambahan) {
    return (
      <div className="my-5 flex flex-col gap-y-3">
        {Array(7)
          .fill(null)
          .map((_, index) => {
            return <SkeletonRow key={index} />;
          })}
      </div>
    );
  }

  return (
    <section className="relative">
      <div className="flex flex-col gap-y-3">
        {isBiayaHidupPerbulanMelebihiTotalPenghasilan && (
          <div>
            <Label>
              Berikan keterangan kenapa Biaya hidup per Bulan melebihi total
              penghasilan keluarga yang anda isi ?
            </Label>
            <Textarea
              // required
              placeholder="Ketik keterangan kenapa Biaya hidup per Bulan melebihi total penghasilan keluarga..."
              value={form.ket_biaya_hidup_lebih_penghasilan}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  ket_biaya_hidup_lebih_penghasilan: event.target.value,
                }))
              }
            />
            <InputError
              text={error?.response?.data?.errors?.ket_biaya_hidup_lebih_penghasilan?.join(
                ",",
              )}
            />
          </div>
        )}
        <div>
          <Label>
            Darimana anda mengetahui informasi program studi yang anda pilih?
          </Label>
          <Combobox
            open={openSumberInformasi}
            setOpen={setOpenSumberInformasi}
            value={form.mengetahui_undiksha || ""}
            setValue={(newValue) =>
              setForm((prev) => ({
                ...prev,
                mengetahui_undiksha: newValue,
              }))
            }
            options={listSumberInformasi}
            placeholder="Silahkan Pilih"
          />
          <InputError
            text={error?.response?.data?.errors?.mengetahui_undiksha?.join(",")}
          />
        </div>
        <div>
          <Label>Kenapa Memilih {web.univAcronym}?</Label>
          <Textarea
            required
            placeholder={`Ketik alasan anda memilih ${web.univAcronym}...`}
            value={form.kenapa_undiksha}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                kenapa_undiksha: event.target.value,
              }))
            }
          />
          <InputError
            text={error?.response?.data?.errors?.kenapa_undiksha?.join(",")}
          />
        </div>
        <div>
          <Label>Url Facebook</Label>
          <Input
            placeholder={`Ketik url facebook anda (contoh: www.facebook.com/${web.univAcronym}.bali)`}
            value={form.url_fb}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                url_fb: event.target.value,
              }))
            }
          />
        </div>
        <div>
          <Label>Twitter</Label>
          <Input
            placeholder={`Ketik twitter anda (contoh: @${web.univAcronym})`}
            value={form.twitter}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                twitter: event.target.value,
              }))
            }
          />
        </div>
        <div>
          <Label>Instagram</Label>
          <Input
            placeholder={`Ketik instagram anda (contoh: @${web.univAcronym}.bali)`}
            value={form.instagram}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                instagram: event.target.value,
              }))
            }
          />
        </div>
        <div>
          <Label>Tiktok</Label>
          <Input
            placeholder={`Ketik tiktok anda (contoh: @${web.univAcronym}.bali)`}
            value={form.tiktok}
            onChange={(event) =>
              setForm((prev) => ({
                ...prev,
                tiktok: event.target.value,
              }))
            }
          />
        </div>
        {/* 
        {!isValidPermanen ? (
          <Button
            variant={dataSurvey ? "outline" : "default"}
            className="mt-3 w-fit ml-auto"
            disabled={isPending}
          >
            {isPending ? (
              <>
                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                Processing...
              </>
            ) : (
              <div className="flex gap-3">
                {dataSurvey ? "Perbarui Survey" : "Simpan Survey"}
              </div>
            )}
          </Button>
        ) : (
          ""
        )} */}
      </div>
    </section>
  );
}
